import { languageMap } from ".."
import { bracketIndenting } from "./shared"

languageMap.processing = bracketIndenting()
